export enum EntityDetailsMode {
  VIEW = 'view',
  EDIT = 'edit',
  ADD = 'add',
  REPORT = 'report',
}
